import React, { Fragment, useContext } from 'react';
import { AlignCenter } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import CustomizerContext from '../../_helper/Customizer';

const Leftbar = () => {
    const { toggleIcon, toggleSidebar } = useContext(CustomizerContext);
    return (
        <Fragment>
            <div className="header-logo-wrapper col-auto p-0">
                <div className="logo-wrapper">
                    <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                        <Image attrImage={{ className: 'img-fluid for-light', src: `${require("../../assets/images/logo/logo.png")}`, alt: '' }} />
                        <Image attrImage={{ className: 'img-fluid for-dark', src: `${require("../../assets/images/logo/logo-dark.png")}`, alt: '' }} />
                    </Link>
                </div>
                {/* Hamburger — visible on all breakpoints. Toggles the sidebar and
                    persists the preference on desktop (via toggleSidebar). */}
                <div
                    className="toggle-sidebar"
                    role="button"
                    tabIndex={0}
                    aria-label="Toggle sidebar"
                    onClick={() => toggleSidebar(!toggleIcon)}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSidebar(!toggleIcon); } }}
                >
                    <AlignCenter className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
                </div>
            </div>
        </Fragment >
    );
};
export default Leftbar;